import React, { useEffect, useState } from "react";
import styles from "./styles.module.scss";

interface NavV2Props {
  signupLink: string;
  loginLink?: string;
}

const links = [
  { label: "Quem somos", href: "#sobre" },
  { label: "Como funciona", href: "#como-funciona" },
  { label: "Marcas", href: "#marcas" },
  { label: "Benefícios", href: "#beneficios" },
  { label: "FAQ", href: "#faq" },
];

const NavV2: React.FC<NavV2Props> = ({ signupLink, loginLink = "/signin" }) => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    document.body.style.overflow = open ? "hidden" : "";
    return () => {
      document.body.style.overflow = "";
    };
  }, [open]);

  return (
    <div className={styles.navWrap}>
      <nav className={`${styles.nav} ${open ? styles.navOpen : ""}`}>
        <div className={styles.bar}>
          <a href="#topo" className={styles.logo} title="Parceiros Promo">
            <img
              src="/images-capa2/global/logo-branco.svg"
              alt="Parceiros Promo"
              width={184}
              height={32}
            />
          </a>

          <ul className={styles.links}>
            {links.map((l) => (
              <li key={l.href}>
                <a href={l.href}>{l.label}</a>
              </li>
            ))}
          </ul>

          <div className={styles.actions}>
            <a
              href={signupLink}
              className={styles.cta}
              title="Quero ser Parceiro"
            >
              <img
                src="/images-capa2/global/logo-mark.svg"
                alt="quero ser parceiro"
                width={20}
                height={20}
              />
              <span>Quero ser Parceiro</span>
            </a>
            <a href={loginLink} className={styles.login} title="Login">
              Login
            </a>
          </div>

          <button
            type="button"
            className={styles.burger}
            aria-label={open ? "Fechar menu" : "Abrir menu"}
            aria-expanded={open}
            onClick={() => setOpen((o) => !o)}
          >
            {open ? (
              <svg width="16" height="16" viewBox="0 0 16 16" aria-hidden="true">
                <path
                  d="M1 1L15 15M15 1L1 15"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                />
              </svg>
            ) : (
              <svg width="18" height="14" viewBox="0 0 18 14" aria-hidden="true">
                <path
                  d="M1 1H17M1 7H17M1 13H17"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                />
              </svg>
            )}
          </button>
        </div>

        {open && (
          <div className={styles.menu} role="dialog" aria-modal="true">
            <ul className={styles.menuLinks}>
              {links.map((l) => (
                <li key={l.href}>
                  <a href={l.href} onClick={() => setOpen(false)}>
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>

            <div className={styles.menuActions}>
              <a
                href={signupLink}
                className={styles.cta}
                title="Quero ser Parceiro"
                onClick={() => setOpen(false)}
              >
                <img
                  src="/images-capa2/global/logo-mark.svg"
                  alt="quero ser parceiro"
                  width={20}
                  height={20}
                />
                <span>Quero ser Parceiro</span>
              </a>
              <a
                href={loginLink}
                className={styles.login}
                title="Login"
                onClick={() => setOpen(false)}
              >
                Login
              </a>
            </div>
          </div>
        )}
      </nav>
    </div>
  );
};

export default NavV2;
